import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components';
import { Footer } from '../../containers';
import Seo from '../../seo/Seo';
import { SERVICES, servicePath } from '../../data/services.mjs';

/**
 * Página 404. Se prerenderiza como build/404.html y Apache la sirve con status 404
 * (ver public/.htaccess). Lleva noindex para no ensuciar el índice.
 */
const NotFoundPage = () => {
    return (
        <>
            <Seo title="Página no encontrada" description="La página que busca no existe o fue movida." path="/404" noindex />
            <Navbar />
            <section className="container py-5 my-5 text-center">
                <p className="fables-second-text-color font-weight-bold mb-2">Error 404</p>
                <h1 className="fables-main-text-color font-weight-bold mb-3">Página no encontrada</h1>
                <p className="fables-forth-text-color mb-4">
                    La página que busca no existe o fue movida. Estas son algunas secciones que pueden interesarle:
                </p>
                <ul className="list-unstyled mb-4">
                    <li className="mb-2"><Link to="/">Inicio</Link></li>
                    <li className="mb-2"><Link to="/facturacion-electronica">Facturación electrónica y contabilidad</Link></li>
                    {SERVICES.map((s) => (
                        <li className="mb-2" key={s.slug}>
                            <Link to={servicePath(s.slug)}>{s.name}</Link>
                        </li>
                    ))}
                    <li className="mb-2"><Link to="/soporte">Soporte</Link></li>
                </ul>
                <Link to="/" className="btn fables-second-background-color white-color rounded-0 px-4 py-2">
                    Volver al inicio
                </Link>
            </section>
            <Footer />
        </>
    );
};

export default NotFoundPage;
